"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { forwardRef as t } from "react";
import { twMerge as n } from "tailwind-merge";
import { jsx as r } from "react/jsx-runtime";
import { cva as i } from "class-variance-authority";
import * as a from "@radix-ui/react-separator";
//#region src/components/atoms/Divider/Divider.tsx
var o = i("border-none shrink-0", {
	variants: {
		orientation: {
			horizontal: "w-full",
			vertical: "h-full"
		},
		thickness: {
			thin: "",
			thick: ""
		},
		color: {
			light: "bg-gray-300",
			dark: "bg-gray-800",
			primary: "bg-blue-600",
			secondary: "bg-green-600"
		},
		marginY: {
			none: "my-0",
			small: "my-2",
			medium: "my-4",
			large: "my-6"
		}
	},
	compoundVariants: [
		{
			orientation: "horizontal",
			thickness: "thin",
			className: "h-[2px]"
		},
		{
			orientation: "horizontal",
			thickness: "thick",
			className: "h-[4px]"
		},
		{
			orientation: "vertical",
			thickness: "thin",
			className: "w-[2px]"
		},
		{
			orientation: "vertical",
			thickness: "thick",
			className: "w-[4px]"
		}
	],
	defaultVariants: {
		orientation: "horizontal",
		thickness: "thin",
		color: "light",
		marginY: "medium"
	}
}), s = t(({ thickness: t, color: i, marginY: s, orientation: c = "horizontal", decorative: l = !0, className: u, ...d }, f) => /* @__PURE__ */ r(a.Root, {
	"data-slot": "divider",
	orientation: c,
	decorative: l,
	className: n(e(o({
		orientation: c,
		thickness: t,
		color: i,
		marginY: s
	})), u),
	...d,
	ref: f
}));
s.displayName = "Divider";
//#endregion
export { s as Divider };
